<p>sidenav-content-recharge works!</p>
<div class="row no-padding  justify-content-center full-hight">
    <div class="col-10 side-nav-content full-hight">
      <div class="row justify-content-center side-content full-hight">
        <div class="col-12">
          <div class="row justify-content-center">
            
                <div class="col-12 margin-block-s">
                    <a routerLink="/autopartage" routerLinkActive="active" >
                      <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                          <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Depart-retour.svg"/>
                        Nouvelle réservation</button>
                    </a></div>
                  <div class="col-12 margin-block-s">
              <a routerLink="/user" routerLinkActive="active" >
                <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                    <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Utilisateur.svg"/>
                  Mon profil</button>
              </a></div>
  
            <hr class="col-10" style="	border-top: 1px solid #8c8b8b;">
            <div class="col-12 margin-block-s">
                
              <a routerLink="auth/ma-formule" routerLinkActive="active" >
                <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                    <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Contrat.svg"/>
                  Ma formule</button>
              </a>
            </div>
            <div class="col-12 margin-block-s">
                
              <a routerLink="auth/reservations" routerLinkActive="active">
                <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                    <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Reservation.svg"/>
                  Mes réservations</button>
              </a>
            </div>
        
  
            <div class="col-12 margin-block-s">
                
              <a routerLink="auth/mon-bilan-carbone" routerLinkActive="active">
                <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                    <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Feuille.svg"/>
                  Mon bilan carbone</button>
              </a>
            </div>

            <div class="col-12 margin-block-s">
                
              <a routerLink="faq" routerLinkActive="active">
                <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                    <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_FAQ.svg"/>
                  FAQ</button>
              </a>
            </div>  


            <hr class="col-10" style="	border-top: 1px solid #8c8b8b;">
            <div class="col-12 margin-block-s">
                <a routerLink="/" routerLinkActive="active">
                    <button class="col-12" mat-stroked-button color="" (click)="disconnect();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                        <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Connexion.svg"/>
                        Déconnexion</button>
                  </a>
                  
            </div>
          </div>
        </div>
  
  
  
        <div class="col-12 user-info align-self-end">
  
          <h5 class="col-12 row d-flex justify-content-center">
            <div><mat-icon aria-hidden="false">email</mat-icon></div><div class="ml-2"> contact@clem.mobi</div>
            
          </h5>
          <h5 class="col-12 row d-flex justify-content-center">
            <div><mat-icon aria-hidden="false">phone</mat-icon></div><div class="ml-2"> +331 86 86 85 85</div>
          </h5>
  
        </div>
      </div>
  
    </div>
  
  </div>
  